import { TAGS } from "../constants";
import { CreateMassageArgs, GetMessageThreads, MessageType } from "../types";
import { api } from "./api";

export const messagesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    //message-threads
    getMessageThreadsByPatientId: builder.query<GetMessageThreads[], number>({
      query: (patientId) => ({
        method: "GET",
        url: `/api/message-threads/patient/${patientId}`,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.MESSAGE_THREADS, id: args },
      ],
    }),
    //messages
    getMessages: builder.query<MessageType[], string>({
      query: (slug) => ({
        method: "GET",
        url: `/api/messages/${slug}`,
      }),
      providesTags: [TAGS.MESSAGES],
    }),
    createMessage: builder.mutation<MessageType, CreateMassageArgs>({
      query: (body) => ({
        method: "POST",
        url: `/api/messages`,
        body,
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        dispatch(
          messagesApi.util.updateQueryData(
            "getMessages",
            args.thread_slug,
            (draft) => {
              (draft || []).push(data);
            },
          ),
        );
      },
    }),
    generateSuggestion: builder.query<string, string>({
      query: (thread) => ({
        method: "GET",
        url: `/api/messages/${thread}/suggestion`,
        responseHandler: "text",
      }),
    }),
  }),
});

export const {
  useGetMessageThreadsByPatientIdQuery,
  useGetMessagesQuery,
  useCreateMessageMutation,
  useGenerateSuggestionQuery,
} = messagesApi;
